import { createApp } from "vue";
import VueClickAway from "vue3-click-away";

import Locations from "~/vue/Locations.vue";

// Main app
const locations = async () => {
	const app = createApp(Locations);

	app.use(VueClickAway);
	app.use(window.pinia);

	return app.mount("#locations");
};

// Execute async function
locations().then(() => {
	console.log();
});
